module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_019.png
// module id = 2335
// module chunks = 5